/**
 * Created by olga on 22.01.2025
 */

const TrickyStacksTutorial = function () {
    return new TutorialScenario("tricky", {
        listSteps: TrickyStacksTutorial.listSteps,
        isAvailable: TrickyStacksTutorial.isAvailable
    });
};

TrickyStacksTutorial.listSteps = function () {
    const options = {};
    options.word = function () {
        return Game.currentGame.keypad.getExistedWords()[0];
    };
    
    options.force = Forces.TRICKY_LEVEL;
    options.force.position = MinimalDialogue.POSITIONS.CENTER_LEFT;

    options.highlights = [cleverapps.Scenes.GetSceneComponent(WordGameSceneComponent).boardView];

    return [BoardTutorialHelper.getDiscoverWordStep(options)];
};

TrickyStacksTutorial.isAvailable = function () {
    const game = Game.currentGame;
    return game && game.keypad.tricky && !cleverapps.forces.isShown(Forces.TRICKY_LEVEL);
};